import React from "react";
import '../Common.scss'
import styles from '../Appliances/Appliance.module.scss';
import defaultImage from '../../../assets/default.png'


export default function FalseCeilingOverview({pageDetails}) {
    const { falseCeilingDetails, lightFixtures } = pageDetails.metaData || {};
    const { isFirstPage } = pageDetails
    const fcDetailsHeaderList=["False ceiling required","Area for ceiling", "False ceiling groups"]
    const fcDetailsValuesKey=["false_ceiling_required","area_for_ceiling", "false_ceiling_groups"] 
    
    const lightFixturesHeaderList=["name", "type", "no_of_lights","colour_code_wattage","running_length_in_feet"]
    const lightFixturesValuesKey=["Name", "Type", "No of lights","Colour code wattage","Running length in feet"]

  return (
    <>
        <div className="page-heading">{pageDetails?.name}</div>
         {isFirstPage ? 
         <div className="page-image-container" style={{height:"50%"}}>
            <div className="image-section-container">
                <img crossOrigin="anonymous"  src={pageDetails?.images ? pageDetails?.images?.[0]?.imageUrl : defaultImage} alt="" className="image-view" />
            </div>
        </div>:null}
        <br/>

        {isFirstPage ? 
        <>
        <div style={{whiteSpace:'nowrap',marginLeft:'20px'}} >False Ceiling Details</div>
            <div className={styles["appliances-details"]}>
                <div className={styles["details-table-app"]}>
                        <div className={styles["table-row-app"] + " "+ styles['headings']}>
                            {(fcDetailsHeaderList || []).map((heading, index)=>{
                                return(
                                    <div className={styles["table-cell-app"]}>
                                        {heading}
                                    </div>
                                )})}
                        </div>
                        <div className={styles["table-row-app"]}>
                            {(fcDetailsValuesKey || []).map(key=>{
                                 return <div className={styles["table-cell-app"]}>
                                        {falseCeilingDetails[key] ? Array.isArray(falseCeilingDetails[key]) ? falseCeilingDetails[key].join(", ") : falseCeilingDetails[key] :"NA" }
                                </div> 
                            })}
                        </div>
                </div>
            </div> 
        </>: null}
        {lightFixtures.length>0 ? 
        <>
            <div style={{whiteSpace:'nowrap',marginLeft:'20px'}} >Light Fixtures</div>
            <div className={styles["appliances-details"]}>
            {
            <div className={styles["details-table-app"]}>
                    <div className={styles["table-row-app"] + " "+ styles['headings']}>
                        {(lightFixturesValuesKey || []).map((heading, index)=>{
                            return(
                                <div className={styles["table-cell-app"]}>
                                    {heading}
                                </div>
                            )
                        })}
                    </div>
                {(lightFixtures || []).map((rowData)=>{
                    return(
                        <div className={styles["table-row-app"]}>
                            {(lightFixturesHeaderList || []).map(key=>{
                                return <div className={styles["table-cell-app"]}>
                                        {rowData[key]? rowData[key]:"NA"}
                                </div>
                            })}
                        </div>
                    )
                })}
            </div>
            }
            </div>
        </> : null }
    </>  
  )
}
